import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  fetchAllDriverAction,
  fetchAllHelperAction,
  fetchAllTruckAction,
} from '../actions/crew-action/employee-list.action';
import { CrewsState, Driver, ErrorState, Helper, Truck } from '../types/store.types';

const initialState: CrewsState = {
  loading: false,
  driverList: [],
  helperList: [],
  truckList: [],
  error: null,
};

export const crewSlice = createSlice({
  name: 'crews',
  initialState,
  reducers: {
    updateDriverList: (state, action: PayloadAction<Driver[]>) => {
      state.driverList = action.payload;
    },
    updateHelperList: (state, action: PayloadAction<Helper[]>) => {
      state.helperList = action.payload;
    },
    updateTruckList: (state, action: PayloadAction<Truck[]>) => {
      state.truckList = action.payload;
    },
  },
  extraReducers: (builder) => {
    // ================== FETCH ALL DRIVER ==================
    builder.addCase(fetchAllDriverAction.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchAllDriverAction.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.driverList = payload;
    });
    builder.addCase(fetchAllDriverAction.rejected, (state, { payload }) => {
      state.loading = false;
      state.driverList = [];
      state.error = payload as ErrorState;
    });
    // ================== FETCH ALL HELPER ==================
    builder.addCase(fetchAllHelperAction.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchAllHelperAction.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.helperList = payload;
    });
    builder.addCase(fetchAllHelperAction.rejected, (state, { payload }) => {
      state.loading = false;
      state.helperList = [];
      state.error = payload as ErrorState;
    });
    // ================== FETCH ALL TRUCK ==================
    builder.addCase(fetchAllTruckAction.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchAllTruckAction.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.truckList = payload;
    });
    builder.addCase(fetchAllTruckAction.rejected, (state, { payload }) => {
      state.loading = false;
      state.truckList = [];
      state.error = payload as ErrorState;
    });
  },
});

export const crewActions = crewSlice.actions;

export default crewSlice.reducer;
